<template>
  <div
    id="waterHeaterLearnMoreModal"
    class="modal fade show"
    tabindex="-1"
    role="dialog"
    aria-labelledby="waterHeaterLearnMoreModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content border-0">
        <div class="modal-header text-center border-bottom-0">
          <h5
            class="modal-title flex-grow-1 font-weight-bold"
            id="waterHeaterLearnMoreModalLabel"
            v-html="title"
          ></h5>
          <button
            type="button"
            class="close"
            aria-label="Close"
            v-on:click="closeModal"
          >
            <i
              v-if="isFullscreen"
              class="mp mp-close"
              aria-label="Close"></i>
            <span v-if="!isFullscreen" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <p v-html="body"></p>

          <a
              class="btn btn-primary"
              v-bind:href="learnMoreLink"
              target="_blank"
          >Learn More</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import SegmentMixin from '@/mixins/SegmentMixin';
import $ from 'jquery';

export default {
  name: 'WaterHeaterLearnMoreModal',
  mixins: [SegmentMixin],
  data() {
    return {
      defaultTitle: 'Do you need an electrical panel upgrade?',
      defaultBody: `With today's standard household appliances and 
                    technology, sometimes our current panel cannot 
                    keep up with everything. When transitioning into 
                    a heat pump water heater, most manufacturers 
                    would like for you to have a minimum 200 AMP 
                    panel that could accommodate a 30 AMP breaker 
                    for most installations.`,
    };
  },
  computed: {
    ...mapGetters('cmsText', ['getCMSText']),
    ...mapState('siteSettings', ['settings']),

    title() {
      return (
        this.getCMSText('electrical_panel_upgrade:learn_more:title', {}, this.defaultTitle)
      );
    },

    body() {
      return (
        this.getCMSText('electrical_panel_upgrade:learn_more:body', {}, this.defaultBody)
      );
    },

    learnMoreLink() {
      return this.settings?.rebateConfig?.waterHeaterLearnMoreLink;
    },

    isFullscreen() {
      return (/true/).test(this.$route?.query.fullScreen);
    },
  },
  methods: {
    closeModal() {
      $('#waterHeaterLearnMoreModal').removeClass('show');
      $('#waterHeaterLearnMoreModal').attr('style', 'display: none');
      this.trackEvent('Do-I-need-electrical-panel-modal-closed');
    },
  },
};
</script>
